<lib-product-badge [productBadge]="productBadge$ | async"></lib-product-badge>
